"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8626],{

/***/ 93290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* reexport */ Popover_Popover; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./src/@next/components/organisms/Popoverlay/utils/index.ts + 2 modules
var utils = __webpack_require__(62671);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/organisms/Popoverlay/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        .arrow {\n          left: ",
        "px;\n          top: calc(50% - ",
        " / 2);\n          transform: rotate(270deg);\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        .arrow {\n          right: ",
        "px;\n          top: calc(50% - ",
        " / 2);\n          transform: rotate(90deg);\n        }\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        .arrow {\n          bottom: calc(-",
        " + 1px);\n          left: calc(50% - ",
        ");\n          transform: rotate(180deg);\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        .arrow {\n          top: calc(-",
        " + 2px);\n          left: calc(50% - ",
        ");\n        }\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          .content {\n            flex-direction: row-reverse;\n          }\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: fixed;\n    box-sizing: border-box;\n    pointer-events: none;\n    z-index: 1000;\n    display: flex;\n    width: 100%;\n    height: 100%;\n    min-width: 1px;\n    min-height: 1px;\n    top: 0;\n    left: 0;\n    .overlay-pane {\n      position: absolute;\n      pointer-events: auto;\n      display: flex;\n      max-width: 100%;\n      max-height: 100%;\n      box-sizing: border-box;\n      ",
        "\n      ",
        "\n      ",
        "\n\n      .icon + span {\n        margin-",
        ": 0.5rem;\n      }\n      ",
        "\n    }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var overlayPane = function(placement, size) {
    switch(placement){
        case "right":
            return "transform: translateX(".concat(size, "px);");
        case "left":
            return "transform: translateX(-".concat(size, "px);");
        case "top":
            return "transform: translateY(-".concat(size, "px);");
        case "bottom":
            return "transform: translateY(".concat(size, "px);");
    }
};
var placementArrow = function(placement, arrowSize, arrowRound) {
    switch(placement){
        case "right":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), arrowRound, arrowSize);
        case "left":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), arrowRound, arrowSize);
        case "top":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), arrowSize, arrowSize);
        case "bottom":
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), arrowSize, arrowSize);
    }
};
var Overlay = globalStyles/* styled.div */.zo.div(_templateObject6(), function(param) {
    var placement = param.placement, position = param.position, size = param.size, arrowSize = param.arrowSize, arrowRound = param.arrowRound;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), overlayPane(placement, size), !position && "visibility: hidden;", arrowSize && arrowRound && placementArrow(placement, arrowSize, arrowRound), placement === "right" ? "right" : "left", placement === "right" && (0,styled_components_browser_esm/* css */.iv)(_templateObject4()));
});

;// CONCATENATED MODULE: ./src/@next/components/organisms/Popoverlay/Overlay.tsx







var initialContext = {
    positionHandle: function positionHandle() {
    // do nothing.
    },
    hide: function hide() {
    // do nothing.
    }
};
var OverLayContext = /*#__PURE__*/ react.createContext(initialContext);
var Overlay_Overlay = function(props) {
    var overlayRef = react.useRef(null);
    var targetRef = react.useRef(null);
    var ref = (0,utils/* usePopoverPosition */.Br)(props, targetRef, overlayRef), position = ref.position, placement = ref.placement, show = ref.show, setShow = ref.setShow, positionHandle = ref.positionHandle;
    var timeOut;
    var onMouseOver = function(e) {
        if (!show) {
            setShow(true);
        } else {
            clearTimeout(timeOut);
        }
    };
    var onMouseOut = function(e) {
        timeOut = setTimeout(function() {
            setShow(false);
        }, 500);
    };
    var onMouseEnter = function(e) {
        setShow(true);
    };
    var onMouseLeave = function(e) {
        setShow(false);
    };
    var onClick = function(e) {
        e.stopPropagation();
        setShow(!show);
    };
    var triggers = props.triggers, transformSize = props.transformSize;
    var getOverlayMouse = function() {
        var overlayMouse = {};
        if (!props.contextMenu) {
            if (triggers.indexOf("hover") !== -1) {
                overlayMouse.onMouseEnter = onMouseOver;
                overlayMouse.onMouseLeave = onMouseOut;
            }
        }
        return overlayMouse;
    };
    var getTargetMouse = function() {
        var targetMouse = {};
        if (props.contextMenu) {
            if (triggers.indexOf("click") !== -1) {
                targetMouse.onClick = onClick;
            }
        } else {
            if (triggers.indexOf("hint") !== -1) {
                targetMouse.onMouseEnter = onMouseEnter;
                targetMouse.onMouseLeave = onMouseLeave;
                targetMouse.onTouchStart = onMouseEnter;
                targetMouse.onTouchEnd = onMouseLeave;
            }
            if (triggers.indexOf("hover") !== -1) {
                targetMouse.onMouseEnter = onMouseOver;
                targetMouse.onMouseLeave = onMouseOut;
                targetMouse.onTouchStart = onMouseOver;
                targetMouse.onTouchEnd = onMouseOut;
            }
            if (triggers.indexOf("click") !== -1) {
                targetMouse.onClick = onClick;
            }
        }
        return targetMouse;
    };
    var overlayProviderValue = (0,react.useMemo)(function() {
        return {
            positionHandle: positionHandle,
            hide: function() {
                return setShow(false);
            }
        };
    }, [
        positionHandle,
        setShow
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                style: props.style,
                className: props.className,
                ref: targetRef
            }, getTargetMouse()), {
                children: props.target
            })),
            show && /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {
                position: !!position,
                placement: placement,
                size: transformSize,
                arrowRound: props.arrowRound,
                arrowSize: props.arrowSize,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverLayContext.Provider, {
                    value: overlayProviderValue,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: "overlay-pane",
                        style: position && {
                            top: position.top,
                            left: position.left
                        },
                        ref: overlayRef,
                        onClick: function(e) {
                            return e.stopPropagation();
                        }
                    }, getOverlayMouse()), {
                        children: props.children
                    }))
                })
            }), document.getElementById("popover-root"))
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/Popoverlay/index.ts



;// CONCATENATED MODULE: ./src/@next/components/organisms/Popover/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: ",
        " solid ",
        ";\n    border-radius: ",
        ";\n    background: ",
        ";\n    box-shadow: ",
        ";\n    color: ",
        ";\n\n    .primitive-overlay {\n      font-family: ",
        ";\n      font-size: ",
        ";\n      line-height: ",
        ";\n      padding: ",
        ";\n    }\n\n    .arrow {\n      position: absolute;\n      width: 0;\n      height: 0;\n      border-left: ",
        " solid transparent;\n      border-right: ",
        " solid transparent;\n      border-bottom: ",
        " solid\n        ",
        ";\n\n      &::after {\n        position: absolute;\n        content: ' ';\n        width: 0;\n        height: 0;\n        top: 3px;\n        left: calc(50% - ",
        ");\n        border-left: ",
        " solid transparent;\n        border-right: ",
        " solid transparent;\n        border-bottom: ",
        " solid\n          ",
        ";\n        clip-path: inset(0 0 2px);\n      }\n    }\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: ",
        " solid ",
        ";\n    border-radius: ",
        ";\n    background: ",
        ";\n    box-shadow: ",
        ";\n    color: ",
        ";\n\n    .primitive-overlay {\n      font-family: ",
        ";\n      font-size: ",
        ";\n      line-height: ",
        ";\n      padding: ",
        ";\n    }\n\n    .arrow {\n      display: none;\n    }\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        "\n  "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var filled = (0,styled_components_browser_esm/* css */.iv)(styles_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject(), theme.popover.borderWidth, theme.popover.borderColor, theme.popover.borderRadius, theme.popover.backgroundColor, theme.popover.shadow, theme.colors.white, theme.typography.baseFontFamily, theme.typography.smallFontSize, theme.typography.baseLineHeight, theme.popover.padding, theme.popover.arrowSize, theme.popover.arrowSize, theme.popover.arrowSize, theme.popover.borderColor, theme.popover.arrowSize, theme.popover.arrowSize, theme.popover.arrowSize, theme.popover.arrowSize, theme.popover.backgroundColor);
});
var outline = (0,styled_components_browser_esm/* css */.iv)(styles_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject2(), theme.popover.borderWidth, theme.colors.red, theme.popover.borderRadius, theme.colors.white, theme.popover.shadow, theme.colors.baseFontColor, theme.typography.baseFontFamily, theme.typography.smallFontSize, theme.typography.baseLineHeight, theme.popover.padding);
});
var appearances = {
    filled: filled,
    outline: outline
};
var Popover = globalStyles/* styled.div */.zo.div(styles_templateObject5(), function(param) {
    var appearance = param.appearance;
    return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject4(), appearance && appearances[appearance]);
});

;// CONCATENATED MODULE: ./src/@next/components/organisms/Popover/Popover.tsx






var Popover_Popover = function(_param) {
    var _appearance = _param.appearance, appearance = _appearance === void 0 ? "filled" : _appearance, props = (0,_object_without_properties/* default */.Z)(_param, [
        "appearance"
    ]);
    var theme = react.useContext(styled_components_browser_esm/* ThemeContext */.Ni);
    var arrowSize = parseInt(theme.popover.arrowSize, 10);
    var arrowRound = Math.round(-arrowSize - arrowSize / 2);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay_Overlay, {
        target: props.children,
        placement: props.placement,
        triggers: props.triggers,
        style: props.style,
        className: props.className,
        eventListener: props.eventListener,
        transformSize: 10,
        arrowRound: arrowRound,
        arrowSize: theme.popover.arrowSize,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover, {
            appearance: appearance,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "arrow"
                }),
                typeof props.overlay === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "primitive-overlay",
                    children: props.overlay
                }) : props.overlay
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/@next/components/organisms/Popover/index.ts



/***/ }),

/***/ 86534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SS": function() { return /* reexport */ queryTypes; },
  "v1": function() { return /* reexport */ useQueryState; },
  "XI": function() { return /* reexport */ useQueryStates; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/@next/hooks/useQueryState/defs.ts


var queryTypes = {
    string: {
        parse: function(v) {
            return v;
        },
        serialize: function(v) {
            return "".concat(v);
        },
        withDefault: function withDefault(defaultValue) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                defaultValue: defaultValue
            });
        }
    },
    integer: {
        parse: function(v) {
            return parseInt(v, 10);
        },
        serialize: function(v) {
            return Math.round(v).toFixed();
        },
        withDefault: function withDefault(defaultValue) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                defaultValue: defaultValue
            });
        }
    },
    float: {
        parse: function(v) {
            return parseFloat(v);
        },
        serialize: function(v) {
            return v.toString();
        },
        withDefault: function withDefault(defaultValue) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                defaultValue: defaultValue
            });
        }
    },
    boolean: {
        parse: function(v) {
            return v === "true";
        },
        serialize: function(v) {
            return v ? "true" : "false";
        },
        withDefault: function withDefault(defaultValue) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                defaultValue: defaultValue
            });
        }
    },
    timestamp: {
        parse: function(v) {
            return new Date(parseInt(v, 10));
        },
        serialize: function(v) {
            return v.valueOf().toString();
        },
        withDefault: function withDefault(defaultValue) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                defaultValue: defaultValue
            });
        }
    },
    isoDateTime: {
        parse: function(v) {
            return new Date(v);
        },
        serialize: function(v) {
            return v.toISOString();
        },
        withDefault: function withDefault(defaultValue) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                defaultValue: defaultValue
            });
        }
    },
    stringEnum: function stringEnum(validValues) {
        return {
            parse: function(query) {
                var asEnum = query;
                if (validValues.includes(asEnum)) {
                    return asEnum;
                }
                return null;
            },
            serialize: function(value) {
                return value.toString();
            },
            withDefault: function withDefault(defaultValue) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                    defaultValue: defaultValue
                });
            }
        };
    },
    json: function json() {
        return {
            parse: function(query) {
                try {
                    return JSON.parse(decodeURIComponent(query));
                } catch (e) {
                    return null;
                }
            },
            serialize: function(value) {
                return encodeURIComponent(JSON.stringify(value));
            },
            withDefault: function withDefault(defaultValue) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                    defaultValue: defaultValue
                });
            }
        };
    },
    array: function array(itemSerializers) {
        var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
        return {
            parse: function(query) {
                return query.split(separator).map(function(item) {
                    return decodeURIComponent(item);
                }).map(itemSerializers.parse).filter(function(value) {
                    return value !== null && value !== undefined;
                });
            },
            serialize: function(values) {
                return values.map(function(value) {
                    if (itemSerializers.serialize) {
                        return itemSerializers.serialize(value);
                    }
                    return "".concat(value);
                }).map(encodeURIComponent).join(separator);
            },
            withDefault: function withDefault(defaultValue) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, this), {
                    defaultValue: defaultValue
                });
            }
        };
    }
};

// EXTERNAL MODULE: ./node_modules/next-translate-routes/router.js
var next_translate_routes_router = __webpack_require__(56827);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/@next/hooks/useQueryState/useQueryState.ts


/**
 * React state hook synchronized with a URL query string in Next.js
 *
 * If used without a `defaultValue` supplied in the options, and the query is
 * missing in the URL, the state will be `null`.
 *
 * ### Behaviour with default values:
 *
 * _Note: the URL will **not** be updated with the default value if the query
 * is missing._
 *
 * Setting the value to `null` will clear the query in the URL, and return
 * the default value as state.
 *
 * Example usage:
 * ```ts
 *   // Blog posts filtering by tag
 *   const [tag, selectTag] = useQueryState('tag')
 *   const filteredPosts = posts.filter(post => tag ? post.tag === tag : true)
 *   const clearTag = () => selectTag(null)
 *
 *   // With default values
 *
 *   const [count, setCount] = useQueryState(
 *     'count',
 *     queryTypes.integer.defaultValue(0)
 *   )
 *
 *   const increment = () => setCount(oldCount => oldCount + 1)
 *   const decrement = () => setCount(oldCount => oldCount - 1)
 *   const clearCountQuery = () => setCount(null)
 *
 *   // --
 *
 *   const [date, setDate] = useQueryState(
 *     'date',
 *     queryTypes.isoDateTime.withDefault(new Date('2021-01-01'))
 *   )
 *
 *   const setToNow = () => setDate(new Date())
 *   const addOneHour = () => {
 *     setDate(oldDate => new Date(oldDate.valueOf() + 3600_000))
 *   }
 * ```
 * @param key The URL query string key to bind to
 * @param options - Serializers (defines the state data type), optional default value and history mode.
 */ function useQueryState(key) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        history: "replace",
        parse: function(x) {
            return x;
        },
        serialize: String,
        defaultValue: undefined
    }, _history = ref.history, history = _history === void 0 ? "replace" : _history, _parse = ref.parse, parse = _parse === void 0 ? function(x) {
        return x;
    } : _parse, _serialize = ref.serialize, serialize = _serialize === void 0 ? String : _serialize, _defaultValue = ref.defaultValue, defaultValue = _defaultValue === void 0 ? undefined : _defaultValue;
    var router = (0,next_translate_routes_router.useRouter)();
    // Memoizing the update function has the advantage of making it
    // immutable as long as `history` stays the same.
    // It reduces the amount of reactivity needed to update the state.
    var updateUrl = react.useMemo(function() {
        return history === "push" ? router.push : router.replace;
    }, [
        history
    ]);
    var getValue = react.useCallback(function() {
        if (false) {}
        var query = new URLSearchParams(window.location.search);
        var value = query.get(key);
        return value !== null ? parse(value) : null;
    }, []);
    // Update the state value only when the relevant key changes.
    // Because we're not calling getValue in the function argument
    // of React.useMemo, but instead using it as the function to call,
    // there is no need to pass it in the dependency array.
    var value = react.useMemo(getValue, [
        router.query[key]
    ]);
    var update = react.useCallback(function(stateUpdater, transitionOptions) {
        var isUpdaterFunction = function(input) {
            return typeof input === "function";
        };
        var ref, ref1;
        // Resolve the new value based on old value & updater
        var oldValue = (ref1 = (ref = getValue()) !== null && ref !== void 0 ? ref : defaultValue) !== null && ref1 !== void 0 ? ref1 : null;
        var newValue = isUpdaterFunction(stateUpdater) ? stateUpdater(oldValue) : stateUpdater;
        // We can't rely on router.query here to avoid causing
        // unnecessary renders when other query parameters change.
        // URLSearchParams is already polyfilled by Next.js
        var query = new URLSearchParams(window.location.search);
        if (newValue === null) {
            // Don't leave value-less keys hanging
            query.delete(key);
        } else {
            query.set(key, serialize(newValue));
        }
        var search = query.toString();
        var hash = window.location.hash;
        return updateUrl === null || updateUrl === void 0 ? void 0 : updateUrl.call(router, {
            pathname: router.asPath.split(/[?#]/)[0],
            hash: hash,
            search: search
        }, {
            pathname: router.asPath.split(/[?#]/)[0],
            hash: hash,
            search: search
        }, transitionOptions);
    }, [
        key,
        updateUrl
    ]);
    var ref1;
    return [
        (ref1 = value !== null && value !== void 0 ? value : defaultValue) !== null && ref1 !== void 0 ? ref1 : null,
        update
    ];
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/@next/hooks/useQueryState/useQueryStates.ts





/**
 * Synchronise multiple query string arguments to React state in Next.js
 *
 * @param keys - An object describing the keys to synchronise and how to
 *               serialise and parse them.
 *               Use `queryTypes.(string|integer|float)` for quick shorthands.
 */ function useQueryStates(keys) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _history = ref.history, history = _history === void 0 ? "replace" : _history;
    var router = (0,next_translate_routes_router.useRouter)();
    // Memoizing the update function has the advantage of making it
    // immutable as long as `history` stays the same.
    // It reduces the amount of reactivity needed to update the state.
    var updateUrl = react.useMemo(function() {
        return history === "push" ? router.push : router.replace;
    }, [
        history
    ]);
    var getValues = react.useCallback(function() {
        if (false) {}
        var query = new URLSearchParams(window.location.search);
        return Object.keys(keys).reduce(function(values, key) {
            var _key = keys[key], parse = _key.parse, defaultValue = _key.defaultValue;
            var value = query.get(key);
            var ref, ref1;
            var parsed = value !== null ? (ref1 = (ref = parse(value)) !== null && ref !== void 0 ? ref : defaultValue) !== null && ref1 !== void 0 ? ref1 : null : defaultValue !== null && defaultValue !== void 0 ? defaultValue : null;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), (0,_define_property/* default */.Z)({}, key, parsed));
        }, {});
    }, [
        keys
    ]);
    // Update the state values only when the relevant keys change.
    // Because we're not calling getValues in the function argument
    // of React.useMemo, but instead using it as the function to call,
    // there is no need to pass it in the dependency array.
    var values = react.useMemo(getValues, Object.keys(keys).map(function(key) {
        return router.query[key];
    }));
    var update = react.useCallback(function(stateUpdater, transitionOptions) {
        var isUpdaterFunction = function(input) {
            return typeof input === "function";
        };
        // Resolve the new values based on old values & updater
        var oldValues = getValues();
        var newValues = isUpdaterFunction(stateUpdater) ? stateUpdater(oldValues) : stateUpdater;
        // We can't rely on router.query here to avoid causing
        // unnecessary renders when other query parameters change.
        // URLSearchParams is already polyfilled by Next.js
        var query = new URLSearchParams(window.location.search);
        Object.keys(newValues).forEach(function(key) {
            var newValue = newValues[key];
            if (newValue === null) {
                query.delete(key);
            } else if (newValue !== undefined) {
                var _key = keys[key], _serialize = _key.serialize, serialize = _serialize === void 0 ? String : _serialize;
                query.set(key, serialize(newValue));
            }
        });
        var search = query.toString();
        var hash = window.location.hash;
        return updateUrl === null || updateUrl === void 0 ? void 0 : updateUrl.call(router, {
            pathname: router.asPath.split(/[?#]/)[0],
            hash: hash,
            search: search
        }, {
            pathname: router.asPath.split(/[?#]/)[0],
            hash: hash,
            search: search
        }, transitionOptions);
    }, [
        keys,
        updateUrl
    ]);
    return [
        values,
        update
    ];
}

;// CONCATENATED MODULE: ./src/@next/hooks/useQueryState/index.ts





/***/ }),

/***/ 61675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ colorsDictionary; }
/* harmony export */ });
var colorsDictionary = {
    "door-color-1": "#292A30",
    "door-color-2": "#50575A",
    "door-color-3": "#4D3827",
    "door-color-4": "#8D7B66",
    "door-color-5": "#D7BEAF"
};


/***/ }),

/***/ 10110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getTextureThumbnailUrl; }
/* harmony export */ });
/* eslint-disable */ var mediaBucketUrl = "https://images.renodoors.eu/";
var getTextureThumbnailUrl = function(textureName) {
    return textureName && "".concat(mediaBucketUrl, "textures-thumbnails/").concat(textureName, ".jpg");
};


/***/ }),

/***/ 45747:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/cross.svg";

/***/ })

}]);